import { TUseEntityTransactionReturn } from '../types'

const ENTITY_TRANSACTION_DEFAULT_OBJ: TUseEntityTransactionReturn = {
  isError: false,
  isLoading: false,
  isNavigateToHome: false,
  traceDetails: '',
  icon: '',
  title: '',
  details: '',
  footnote: '',
}

const ENTITY_TRANSACTION_DURATION_MS = 3000

export { ENTITY_TRANSACTION_DEFAULT_OBJ, ENTITY_TRANSACTION_DURATION_MS }
